import React from "react";
import "./LoadingContainer.css";
import loadingGif from "../../assets/loading.gif";

const LoadingContainer = ({ message = null }) => {
  return (
    <div className="loading-container">
      <img src={loadingGif} alt="Loading..." />
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default LoadingContainer;
